import SelectIcon from '@svgIcons/select.svg';

import PanelOptionMixin from '../mixin';

import * as C from '../../options/styles';

export default {
    name: 'QuickMenuVisibleToggleOption',
    mixins: [PanelOptionMixin],
    props: {
        quickMenuVisible: { type: Boolean, default: true },
    },
    render() {
        const { quickMenuVisible } = this;

        return this.wrapOptions({
            title: this.$t('FIELD_PANEL.quick_control_setting.title'),
            tooltipTitle: this.$t('FIELD_PANEL.quick_control_setting.tooltip'),
            icon: (
                <C.IconWrapper>
                    <SelectIcon class="select-icon" />
                </C.IconWrapper>
            ),
            hasEditBtn: false,
            hasSwitch: true,
            isSwitchActive: quickMenuVisible,
            onClick: () => {
                this.$emit('update', !quickMenuVisible);
            },
        });
    },
};
